import { useCallback, useMemo, useState } from 'react'
import { useGetAnimalList } from 'src/hooks/api/animal'
import { useGetBreedList } from 'src/hooks/api/breed'

export const useAnimalList = () => {
  const [searchValue, setSearchValue] = useState('')

  const { data: breedList, isLoading: isLoadingBreedListing } = useGetBreedList()

  const queryParams = useMemo(
    () => (searchValue ? { searchFields: 'nome,brinco,sexo,rgn,raca', search: searchValue } : {}),
    [searchValue]
  )

  const {
    data: animalListData,
    isLoading: isLoadingAnimalListing,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
    isError
  } = useGetAnimalList('getAnimalList', queryParams)

  const animalListRaw = animalListData?.pages.flatMap((p) => p.list) ?? []

  const animalList = useMemo(() => {
    if (!breedList) return animalListRaw

    return animalListRaw.map((animal) => {
      const breed = breedList.find((b) => b.idRaca === animal.raca)
      return breed ? { ...animal, raca: breed.descricao } : animal
    })
  }, [animalListRaw, breedList])

  const handleSearchChange = useCallback((value: string) => {
    setSearchValue(value)
  }, [])

  return {
    animalList,
    animalListData,
    isLoadingAnimalListing: isLoadingAnimalListing || isFetching,
    isLoadingBreedListing,
    isFetchingNextPage,
    fetchNextPage,
    searchValue,
    handleSearchChange,
    refetch,
    isError
  }
}
